import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import secureLocalStorage from "react-secure-storage";

const size = {
  width: 400,
  height: 150,
};

const StyledText = styled("text")(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 13,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export default function PieChartExpenses({ claimData }) {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const userBranch = user?.results?.branch;
  const userData = claimData.filter((data) => data.branch === userBranch);
  const allUserData = claimData.filter((data) => data.branch !== userBranch);
  const userAmount = userData.reduce((acc, val) => acc + val.amount, 0);
  const allUserAmount = allUserData.reduce((acc, val) => acc + val.amount, 0);
  const data = [
    { value: userAmount, label: "Your Branch", color: "#b91c1c" },
    { value: allUserAmount, label: "All Branches" },
  ];
  return (
    <PieChart series={[{ data, innerRadius: 30 }]} {...size}>
      <PieCenterLabel>Expenses</PieCenterLabel>
    </PieChart>
  );
}
